import React, {useMemo, useState} from "react";
import {Box, IconButton, Typography} from "@mui/material";
import {Edit as EditIcon, RemoveCircle as RemoveIcon} from "@mui/icons-material";
import {ItemDialog} from "../dialogs";
import {default as InlineAdd} from "./inlineAdd";
import {arrays, objects} from "@atttomyx/shared-utils";
import {confirm} from "@atttomyx/react-utils";
import {nodeUtils} from "../../utils";
import "./items.css";

const BOX_STYLE = {
    display: "flex",
    flexDirection: "column",
    textAlign: "left"
};

const Items = (props) => {
    const {data, onChange, label, field, form, options,
        formatter, toLines, toItem} = props;
    const [datum, setDatum] = useState(null);

    const list = useMemo(() => {
        const array = data[field];
        const filtered = array ? arrays.copy(array.filter(objects.notNullOrUndefined)) : [];

        return filtered.sort(nodeUtils.sortByLabel);
    }, [data, field]);

    const editItem = (item, index) => {
        const decorated = objects.deepCopy(item);

        decorated.index = index;
        setDatum(decorated);
    };

    const removeItem = (index) => {
        const modified = objects.deepCopy(data);
        const array = arrays.copy(list);

        array.splice(index, 1);
        modified[field] = array;

        onChange(modified);
    };

    const insertItem = (item) => {
        const modified = objects.deepCopy(data);
        const array = arrays.copy(list);

        const sanitized = toItem
            ? toItem(item)
            : {
                label: item.label,
                value: item.value,
              };

        if (objects.notNullOrUndefined(item.index)) {
            array.splice(item.index, 1, sanitized);

        } else {
            arrays.addTo(array, sanitized);
        }

        modified[field] = array;

        onChange(modified);
    };

    return <div className="node-items">
        {list.map((item, index) => (
            <div key={index} className="row">
                <IconButton
                    color="secondary"
                    title="Remove"
                    onClick={() => confirm.confirmDelete(item.label, () => removeItem(index))}
                >
                    <RemoveIcon/>
                </IconButton>
                <Box sx={BOX_STYLE} className="item">
                    <Typography variant="caption" color="text.secondary" className="truncated">
                        {item.label}
                    </Typography>
                    {toLines ? toLines(item).map((line, index) => (
                        <Typography key={index} className="truncated">
                            {line}
                        </Typography>
                    )) :
                        <Typography className="truncated">
                            {formatter ? formatter(item.value) : item.value}
                        </Typography>}
                </Box>
                <IconButton
                    className="right"
                    color="primary"
                    title="Edit"
                    onClick={() => editItem(item, index)}
                >
                    <EditIcon/>
                </IconButton>
            </div>
        ))}
        <div className="row">
            <InlineAdd
                label={label}
                onClick={() => setDatum({})}
            />
        </div>
        {datum ?
            <ItemDialog
                label={label}
                item={datum}
                form={form}
                options={options}
                onCancel={() => setDatum(null)}
                onOk={(item) => {
                    insertItem(item);
                    setDatum(null);
                }}
            /> : null}
    </div>
}

export default Items;
